import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';

export default function SurveyRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const authToken = localStorage.getItem('authToken');
        const res = await fetch(`${API_BASE_URL}/api/profile/status`, { credentials: 'include', headers: authToken ? { Authorization: `Bearer ${authToken}` } : {} });
        if (!mounted) return;
        if (!res.ok) {
          // if not authenticated, send to login
          return navigate('/giris-yap');
        }
        const status = await res.json();
        if (!status.completedRegistration) return navigate('/registration-survey');
        if (status.shouldResumeOnboarding) return navigate('/onboarding-setup');
        return navigate('/dashboard');
      } catch (err) {
        console.error('SurveyRedirect error', err);
        navigate('/giris-yap');
      }
    })();
    return () => { mounted = false; };
  }, [navigate]);

  return <div className="min-h-[60vh] flex items-center justify-center">Yönlendiriliyor…</div>;
}
